import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {TaskDTO} from '../model/taskDTO';
import {TaskOverviewDTO} from '../model/taskOverviewDTO';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'task';

  constructor(private http: HttpClient) {
  }

  getAll(clientId, level: TaskDTO.LevelEnum) {
    let options = {};
    if (clientId != null) {
      options = {params: {clientId: clientId}};
    }
    return this.http.get<Array<TaskDTO>>(`${this.path}/${level}`, options);
  }

  getOverview() {
    return this.http.get<Array<TaskOverviewDTO>>(`${this.path}/overview`);
  }
}
